import React from 'react';
import ReactDOM from 'react-dom';
import App from "./Containers/App";

let root = document.getElementById('search-container');
if (root) {
    ReactDOM.render(<App{...(root.dataset)}/>, root);
}
